import { Technology } from 'src/app/shared/types/technology.types';
import * as TechnologiesActions from '../actions/technologies.actions';

const initialState: Technology[] = null;

export function reducer(state = initialState, action: TechnologiesActions.Actions): Technology[] {
  switch (action.type) {
    case TechnologiesActions.TECHNOLOGIES_LOAD_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
